import * as Scrivito from "scrivito";
import {
  defaultFormInputEditingAttributes,
  defaultFormInputEditingProperties,
  defaultFormInputInitialContent,
} from "../../_defaultFormEditingConfig";

Scrivito.provideEditingConfig("ReceiverEmailInputWidget", {
  title: "Receiver Email Input",
  description:
    "Email address from this input will be used for sending an email to the user, so it should be used only once.",
  attributes: {
    ...defaultFormInputEditingAttributes,
    placeholder: {
      title: "Placeholder",
    },
  },
  properties: [...defaultFormInputEditingProperties, "placeholder"],
  initialContent: {
    ...defaultFormInputInitialContent,
    propertyName: "email",
  },
  validations: [
    [
      "csvColumnName",
      (csvColumnName) => {
        if (!csvColumnName) {
          return "CSV column name is required";
        }
        return null;
      },
    ],
  ],
});
